import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EditArt } from '../_interfaces/EditArt';
import { Employee, EmployeeGroupe } from '../_interfaces/Employee';
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';
import { ITicketState } from '../_interfaces/TicketState';
import { WorkstepBase } from '../_interfaces/workstep';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class TicketEditService {

  private _ticketArts: EditArt[] = []
  private _contactArts: EditArt[] = []
  private _worksteps: EditArt[] = []
  private _employees: Employee[] = []
  private _employeeGroupes: EmployeeGroupe[] = []
  private _contentFrom: EditArt[] = []
  private _ticketStates: ITicketState[] = []

  public ticketArtSearchText: string = ""

  constructor(
    private http: HttpService
  ) { }

  public get ticketArts(): EditArt[]{
    return this._ticketArts
  }

  public set ticketArts(arts: EditArt[]){
    this._ticketArts = arts
  }

  public get contactArts(): EditArt[]{
    return this._contactArts
  }

  public get worksteps(): EditArt[]{
    return this._worksteps
  }

  public get employees(): Employee[]{
    return this._employees
  }
  
  public get employeeGroupes(): EmployeeGroupe[]{
    return this._employeeGroupes
  }
  
  public get contentFrom(): EditArt[]{
    return this._contentFrom
  }

  public set contentFrom(content: EditArt[]){
    this._contentFrom = content
  }

  public addContentFrom(art: EditArt){
    this._contentFrom.push(art)
  }

  public get ticketStates(): ITicketState[]{
    return this._ticketStates
  }

  public set ticketStates(states: ITicketState[]){
    this._ticketStates = states
  }

  public get toCalculateList(): EditArt[]{
    return [
      {id: 0, description: "Nicht berechnen"}, 
      {id: 1, description: "Zu berechnen"},
      {id: 2, description: "Bereits berechnet"},
      {id: 3, description: "Manuell"},]
  }

  public setWorksteps(worksteps: WorkstepBase[]){
    this._worksteps = []
    worksteps.forEach(w =>{
      this._worksteps.push({
        id: w.id,
        description: `Nr.${w.number}${w.description ? ` / ${w.description}` : ""} / ${w.contactDescription} / ${w.employee?.firstName || ""} ${w.employee?.lastName || ""}`
      })
    })
  }

  public addWorkStep(workstep: WorkstepBase){
    this._worksteps.push({
      id: workstep.id,
      description: `Nr.${workstep.number} / ${workstep.contactDescription} / ${workstep.employee.firstName} ${workstep.employee.lastName}`
    })
  }

  public async loadEditInformations(){
    const result: HttpFunctionResult<EditArt[]> = await this.http.GET<EditArt[]>({
      path: "ticket/editinfo/art"
    })
    if(!result.success) return
    const arts: EditArt[] = result.data as EditArt[]
    this._ticketArts = arts.filter(a => a.type === 0)
    this._contactArts = arts.filter(a => a.type === 1)
  }

  public async loadAllEmployees(){

    const result: HttpFunctionResult<any> = await this.http.GET({
      path: "ticket/editinfo/employees"
    })

    if(!result.success) return
    this._employeeGroupes = result.data[0] as EmployeeGroupe[]
    this._employees = result.data[1] as Employee[]
  }

  public async loadAllTicketStates(): Promise<HttpFunctionResult<any>>{

    const result: HttpFunctionResult<ITicketState[]> = await this.http.GET<ITicketState[]>({
      path: "ticket/editinfo/ticketstates"
    })
    if(!result.success) return {success: false}

    this._ticketStates = result.data as ITicketState[]
    return result

  }

  public getSegmentNumberByText(value: string){
    let index: number = 0
    switch (value) {
      case "settings":
        index = 1
        break;
      case "worker":
        index = 2
        break
      case "times":
        index = 3
        break
      default:
        index = 0
        break;
    }
    return index
  }

  public getSegmentTextByNumber(value: number){
    let text: string = ""
    switch (value) {
      case 1:
        text = "settings"
        break;
      case 2:
        text = "worker"
        break
      case 3:
        text = "times"
        break
      default:
        text = "overview"
        break;
    }
    return text
  }

}
